import React, { createContext, useContext, useState, useEffect } from "react";
import { translations } from "@/translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem("masala_lang") || "no";
  });

  useEffect(() => {
    localStorage.setItem("masala_lang", lang);
  }, [lang]);

  const t = (key) => {
    return translations[lang]?.[key] || translations["no"]?.[key] || key;
  };

  const toggleLang = () => {
    setLang((prev) => (prev === "no" ? "en" : "no"));
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
